<template>
    <vx-expandable-card>
        <template v-slot:header> Redeem Coupon </template>
        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <vx-alert v-if="form.successful" color="success" :closeable="false">
                    Coupon accepted! The discount will be applied to your next invoice.
                </vx-alert>
                <vx-alert v-if="form.errors.has('coupon')" color="danger" :closeable="false">
                    {{ form.errors.get('coupon') }}
                </vx-alert>
                <div>
                    <vx-label size="md"> Coupon Code </vx-label>

                    <div class="flex items-center gap-3">
                        <vx-input
                            size="lg"
                            name="coupon"
                            v-model="form.coupon"
                            :error="displayFirstError(validate.form.coupon.$errors)"
                        ></vx-input>
                        <vx-button
                            data-test="submit-button"
                            @click="redeem"
                            :loading="form.busy"
                            :class="{
                                'mb-6': validate.form.coupon.$errors.length,
                            }"
                            >Redeem</vx-button
                        >
                    </div>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script>
import { VxAlert, VxButton, VxExpandableCard, VxInput, VxLabel } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { displayFirstError, validateRules } from '~/utils/validation';

export default {
    components: {
        VxAlert,
        VxButton,
        VxExpandableCard,
        VxLabel,
        VxInput,
    },
    setup() {
        return {
            validate: useVuelidate(),
        };
    },
    validations() {
        return {
            form: {
                coupon: {
                    required,
                },
            },
        };
    },
    props: ['team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                coupon: '',
            }),
        };
    },

    mounted() {
        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate);
    },

    methods: {
        displayFirstError,
        /**
         * Redeem the given coupon code.
         */
        async redeem() {
            this.form.busy = true;
            this.form.errors.forget();
            this.form.successful = false;
            this.validate.$reset();

            if (!(await validateRules(this.validate))) {
                this.form.busy = false;
                this.form.successful = false;

                return;
            }

            Spark.post(this.urlForRedemption, this.form)
                .then(() => {
                    this.form.coupon = '';

                    Bus.$emit('updateDiscount');
                })
                .catch((e) => {
                    console.error(e);

                    this.form.errors.set({ coupon: [e?.errors?.coupon[0] || 'Something went wrong.'] });
                })
                .finally(() => {
                    this.form.busy = false;
                });
        },
    },

    computed: {
        /**
         * Get the URL for redeeming a coupon.
         */
        urlForRedemption() {
            return `/settings/teams/${this.team.id}/payment-method/coupon`;
        },
    },
};
</script>
